import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
  Box,
  Paper
} from '@mui/material';

const CarrierSelectionDialog = ({ open, onClose, onCarrierSelected, isGenerating }) => {
  const [selectedCarrier, setSelectedCarrier] = useState('UPS');

  const handleCarrierChange = (event) => {
    setSelectedCarrier(event.target.value);
  };

  const handleGenerate = () => {
    onCarrierSelected(selectedCarrier);
  };

  const carriers = [
    { value: 'UPS', label: 'UPS Next Day Air', description: 'Brown label with classic UPS design' },
    { value: 'FedEx', label: 'FedEx Home Delivery', description: 'Purple and orange FedEx branding' },
    { value: 'DHL', label: 'DHL Express Easy', description: 'Yellow header with red DHL logo' }
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography variant="h6">Select Carrier for Realistic Label</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Choose which carrier style you want for your realistic shipping label:
        </Typography>
        
        <FormControl component="fieldset" fullWidth>
          <FormLabel component="legend" sx={{ mb: 2 }}>Carrier Style</FormLabel>
          <RadioGroup
            aria-label="carrier"
            name="carrier"
            value={selectedCarrier}
            onChange={handleCarrierChange}
          >
            {carriers.map((carrier) => (
              <Paper 
                key={carrier.value} 
                elevation={selectedCarrier === carrier.value ? 2 : 0}
                sx={{ 
                  p: 2, 
                  mb: 1, 
                  border: selectedCarrier === carrier.value ? '2px solid #1976d2' : '1px solid #e0e0e0',
                  borderRadius: 1
                }}
              >
                <FormControlLabel
                  value={carrier.value}
                  control={<Radio />}
                  label={
                    <Box>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {carrier.label}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {carrier.description}
                      </Typography>
                    </Box>
                  }
                  sx={{ margin: 0, width: '100%' }}
                />
              </Paper>
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isGenerating}>
          Cancel
        </Button>
        <Button 
          onClick={handleGenerate} 
          variant="contained" 
          disabled={isGenerating}
        >
          {isGenerating ? 'Generating...' : 'Generate PDF'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CarrierSelectionDialog; 